import { useAppDispatch } from 'hooks/useAppDispatch';
import { FC } from 'react';
import { useQuery } from 'react-query';
import { modalActions } from 'reduxStore/reducers/ModalSlice';
import { AgentService } from 'services/AgentService';
import { Button } from 'ui/redesign/Button';
import { ButtonVariant } from 'ui/redesign/Button/constants';
import { ClientRequestHandler } from '../types';
import { SignModalActionContentProps } from './types';
import { FileByContent } from 'ui/redesign/FileByContent';
import { Spinner } from 'ui/Spinner';

export const SignModalActionContent: FC<SignModalActionContentProps> = ({
  onSubmit,
  onCreateRequestData,
  id,
  status,
}) => {
  const dispatch = useAppDispatch();

  const requestData = onCreateRequestData();

  const { data, isFetching } = useQuery(['getClientOrderPreview'], () =>
    AgentService.getClientOrderPreview(id, requestData)
  );

  const clientOrderPreview = data?.data;

  return clientOrderPreview ? (
    <>
      <div className="mt-4 mb-8 h-20">
        {isFetching ? (
          <div className="flex pt-4">
            <Spinner />
          </div>
        ) : (
          <FileByContent
            file={clientOrderPreview}
            isHidePreviewFileButton
            specialFileName="Проект акта выполненных работ"
          />
        )}
      </div>
      <div className="z-10 flex justify-end">
        <Button
          variant={ButtonVariant.OUTLINE}
          className="mr-5"
          type="button"
          onClick={() => {
            dispatch(modalActions.closeModal());
          }}
        >
          ОТМЕНИТЬ
        </Button>
        <Button
          variant={ButtonVariant.PRIMARY}
          onClick={() => onSubmit(ClientRequestHandler.SENDFORSIGNBYMODAL, requestData, id, status)}
        >
          ПОДПИСАТЬ
        </Button>
      </div>
    </>
  ) : null;
};
